'use strict';

import { CoreRepository } from '../CoreRepository';
import { IndPolicy } from '../../Entities/Ind/IndPolicy';
import { IndPolicyCollection } from '../../Collections/Ind/IndPolicyCollection';

export class IndPolicyRepository extends CoreRepository {
  /*public getIndPolicy(individualId: number, options: object = {}) {
    if (!options) {
      options = {};
    }
 
    return this.webAPI.getInd(individualId, options)
      .then(response => {
        let user = new Ind();
        user.hydrate(response);
 
        return user;
      });
 
  }
 
  public getInds(options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }
 
    if (criteria) {
      options['criteria'] = criteria;
    }
 
    return this.webAPI.getInds(options)
      .then(response => {
        let collection = new IndCollection();
 
        response.data.forEach(collectionItemData => {
          let collectionItem = new Ind();
          collectionItem.hydrate(collectionItemData);
 
          collection.addItem(collectionItem);
        });
 
        collection.setOffset(response.offset);
        collection.setLimit(response.limit);
        collection.setTotal(response.total);
 
        return collection;
      });
 
  }
 
  public deleteInds(userId: number, individualIds: number[]) {
    return this.webAPI.deleteInds(userId, individualIds)
      .then(response => {
        return response;
      });
 
  }
 */

  public getPolicy(policyId: number, options: object = {}) {
    if (!options) {
      options = {};
    }

    return this.webAPI.getPolicy(policyId, options).then((response) => {
      const user = new IndPolicy();
      user.hydrate(response);

      return user;
    });
  }

  public getIndPolicy(indId: number, policyId: number, options: object = {}) {
    if (!options) {
      options = {};
    }

    return this.webAPI.getIndPolicy(indId, policyId, options).then((response) => {
      const user = new IndPolicy();
      user.hydrate(response);

      return user;
    });
  }

  public updateIndPolicy(indId: number, policyId: number, payload: any[]) {
    return this.webAPI.updateIndPolicy(indId, policyId, payload).then((response) => {
      return response;
    });
  }

  public getUserPolicies(userId: number, type: string, options: object = {}) {
    return this.webAPI.getUserPolicies(userId, type, options).then((response) => {
      const collection = new IndPolicyCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new IndPolicy();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public getPolicies(options: object = {}) {
    return this.webAPI.getPolicies(options).then((response) => {
      const collection = new IndPolicyCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new IndPolicy();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public getPoliciesTotal(options: object = {}) {
    return this.webAPI.getPoliciesTotal(options).then((response) => {
      const collection = new IndPolicyCollection();

      collection.setTotal(response.total);

      return collection;
    });
  }

  public moveIndPolicy(individualId: number, individualPolicyId: number, payload: any[]) {
    return this.webAPI.moveIndPolicy(individualId, individualPolicyId, payload).then((response) => {
      return response;
    });
  }

  public addIndPolicy(indId: number, payload: any[]) {
    return this.webAPI.addIndPolicy(indId, payload).then((response) => {
      const indPolicy = new IndPolicy();
      indPolicy.hydrate(response);

      return indPolicy;
    });
  }
}
